/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum MetricType {
  ActiveTime = 'ActiveTime',
  CaloriesBurned = 'CaloriesBurned',
  HeartRate = 'HeartRate',
  Sleep = 'Sleep',
  Spo2 = 'SPO2',
  Steps = 'Steps',
  Stress = 'Stress',
  V02Max = 'V02Max',
  ActivityActiveTime = 'ActivityActiveTime',
  ActicityAverageHeartRate = 'ActicityAverageHeartRate',
  ActivityMaxHeartRate = 'ActivityMaxHeartRate',
  ActivityCaloriesExpenditure = 'ActivityCaloriesExpenditure',
  ActivityDistanceSteps = 'ActivityDistanceSteps',
  BloodPressureSystolic = 'BloodPressureSystolic',
  BloodPressureDiastolic = 'BloodPressureDiastolic',
  BloodGlucose = 'BloodGlucose',
  Weight = 'Weight',
  BodyFatPercentage = 'BodyFatPercentage',
  SleepMinHeartRateBpmAggregate = 'SleepMinHeartRateBPM_Aggregate',
  SleepMaxHeartRateBpmAggregate = 'SleepMaxHeartRateBPM_Aggregate',
  SleepAverageHeartRateBpmAggregate = 'SleepAverageHeartRateBPM_Aggregate',
  SleepMinHeartRateVariabilitySdnnAggregate = 'SleepMinHeartRateVariabilitySDNN_Aggregate',
  SleepMaxHeartRateVariabilitySdnnAggregate = 'SleepMaxHeartRateVariabilitySDNN_Aggregate',
  SleepAverageHeartRateVariabilitySdnnAggregate = 'SleepAverageHeartRateVariabilitySDNN_Aggregate',
  SleepTimeInBedSecondsAggregate = 'SleepTimeInBedSeconds_Aggregate',
  SleepCoreSleepSecondsAggregate = 'SleepCoreSleepSeconds_Aggregate',
  SleepRemSleepSecondsAggregate = 'SleepRemSleepSeconds_Aggregate',
  SleepDeepSleepSecondsAggregate = 'SleepDeepSleepSeconds_Aggregate',
  SleepTimeAwakeDuringSleepSecondsAggregate = 'SleepTimeAwakeDuringSleepSeconds_Aggregate'
}
